export default __webpack_public_path__ + "static/media/contact.726efd49.svg";